import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogInIcon, LogOutIcon, WrenchIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useEspace } from '../contexts/EspaceContext';
import { useDebug } from '../contexts/DebugContext';
const DEMO_IDENTIFIER = 'marianne.caldwell@courriel.com';
const chip = 'inline-flex items-center gap-1.5 rounded-full border border-white/20 px-3 py-1.5 text-xs font-bold text-white transition-colors duration-150 ease-ville hover:bg-white/15 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60';

/** Barre de mise au point de la maquette : bascule rapidement l'état de session. Repliable. */
export function DebugBar() {
  const [open, setOpen] = useState(false);
  const {
    isAuthenticated,
    login,
    logout
  } = useAuth();
  const {
    exitEspace
  } = useEspace();
  const {
    alreadySubscribed,
    setAlreadySubscribed,
    sso,
    setSso,
    hasCard,
    setHasCard
  } = useDebug();
  const navigate = useNavigate();
  return <div data-no-translate className="pointer-events-none fixed bottom-0 left-0 z-[70] pb-4 pl-4" data-id="element-1062" data-mp="1r05vnqnq2geh">
      <div className="pointer-events-auto overflow-hidden rounded-full bg-ville-navy/95 shadow-xl backdrop-blur" data-id="element-1063" data-mp="1vyh8ma9bd70x">
        <div className={`flex flex-wrap items-center gap-2 ${open ? 'py-1.5 pl-1.5 pr-3' : 'p-1.5'}`} data-id="element-1064" data-mp="1ha33ttsc78hq">
          <button type="button" onClick={() => setOpen(current => !current)} aria-expanded={open} aria-label={open ? 'Replier le debug' : 'Ouvrir le debug'} title="Debug" className="grid h-8 w-8 place-items-center rounded-full text-white/70 transition-colors duration-150 ease-ville hover:bg-white/15 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60" data-id="element-1065" data-mp="1m84k66ydotpi">
            <WrenchIcon className="h-4 w-4" aria-hidden="true" data-id="element-1066" data-mp="2squk0zqdym1m" />
          </button>

          {open && <>
              <span className="h-4 w-px bg-white/20" aria-hidden="true" data-id="element-1067" data-mp="2xocke1qc7sy0" />

              <button type="button" onClick={() => {
            if (isAuthenticated) {
              logout();
              exitEspace();
              navigate('/');
            } else {
              login(DEMO_IDENTIFIER);
            }
          }} className={chip} data-id="element-1068" data-mp="2w8qja6ornvdy">
                {isAuthenticated ? <>
                    <LogOutIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1069" data-mp="3f0b3oleqwxga" />
                    Déconnecter
                  </> : <>
                    <LogInIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1070" data-mp="356u8pe2vhcb1" />
                    Connecter
                  </>}
              </button>

              <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-white/20 px-3 py-1.5 text-xs font-bold text-white transition-colors duration-150 ease-ville hover:bg-white/15" data-id="element-1071" data-mp="1jk3tqno4lw5">
                <input type="checkbox" checked={alreadySubscribed} onChange={event => setAlreadySubscribed(event.target.checked)} className="h-3.5 w-3.5 accent-ville-lime" data-id="element-1072" data-mp="1fgn3n2wqoqe5" />
                Notifié
              </label>

              <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-white/20 px-3 py-1.5 text-xs font-bold text-white transition-colors duration-150 ease-ville hover:bg-white/15" data-id="element-1073" data-mp="1tgo3qg56jtsk">
                <input type="checkbox" checked={sso} onChange={event => setSso(event.target.checked)} className="h-3.5 w-3.5 accent-ville-lime" data-id="element-1074" data-mp="23b69rry2k1fj" />
                SSO
              </label>

              <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-white/20 px-3 py-1.5 text-xs font-bold text-white transition-colors duration-150 ease-ville hover:bg-white/15" data-id="element-1075" data-mp="2h60dbh4f63ve">
                <input type="checkbox" checked={hasCard} onChange={event => setHasCard(event.target.checked)} className="h-3.5 w-3.5 accent-ville-lime" data-id="element-1076" data-mp="28f8e5le0yaa8" />
                Carte citoyenne
              </label>
            </>}
        </div>
      </div>
    </div>;
}